<div class="problem-detail-separater">
  <mat-icon aria-hidden="true">call_received</mat-icon>
</div>
